import { render } from "./ManyToMany.vue?vue&type=template&id=bb430e0e&lang=pug"
import script from "./ManyToMany.vue?vue&type=script&lang=ts"
export * from "./ManyToMany.vue?vue&type=script&lang=ts"
script.render = render

export default script